import type { PropsWithChildren } from 'react'

const fitViewportProps = { 'data-fit-viewport': '' } as const

type AdminViewportPageProps = PropsWithChildren

export const AdminViewportPage = ({ children }: AdminViewportPageProps) => (
  <div {...fitViewportProps} className='flex flex-col not-print:lg:h-full'>
    {children}
  </div>
)

export const AdminPageFrame = ({ children }: PropsWithChildren) => (
  <div className='flex min-h-full flex-col not-print:lg:has-[[data-fit-viewport]]:h-full'>
    {children}
  </div>
)
